import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelReportsReferralCommissionsResolverErrorStatesEnum {
    GetCountriesFailed = ErrorStateScheduleEnum.PanelReportsReferralCommissionsResolverErrorStatesStartIndex
}
